import { Loading, QSpinnerGears, QSpinnerPuff } from "quasar";

function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export class LoadingModal {
  static show(msg = "Por favor aguarde...", isAuthenticating = false) {
    let spinner = QSpinnerGears;
    if (isAuthenticating) {
      spinner = QSpinnerPuff;
    }
    Loading.show({
      spinner: spinner,
      message: msg,
    });
  }

  static confirmationFlash() {
    Loading.show({
      spinner: QSpinnerPuff,
      backgroundColor: "green",
    });

    delay(500).then(() => {
      Loading.hide();
    });
  }

  static errorFlash() {
    Loading.show({
      spinner: QSpinnerPuff,
      backgroundColor: "red",
    });

    delay(500).then(() => {
      Loading.hide();
    });
  }

  static hide() {
    Loading.hide();
  }
}
